import LoginForm from "../../auth/login";
import { Modal, ModalBody, ModalContent, ModalHeader } from "@nextui-org/react";
import { useEffect, useState } from "react";

const CheckLoginModal = ({ isOpen, onClose, onSuccess, productId }) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(window.isLogin);

  useEffect(() => {
    setIsUserLoggedIn(window.isLogin);
  }, [window.isLogin]);

  return (
    <Modal
      isOpen={isOpen && !isUserLoggedIn}
      onClose={onClose}
      size="5xl"
      backdrop="opaque" 
      radius="lg"
      className="dark"
      classNames={{
        body: "py-6",
        backdrop: "bg-[#292f46]/50 backdrop-opacity-40",
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-center text-white">
              Login Required
            </ModalHeader>
            <ModalBody>
              <LoginForm onSuccess={onSuccess} productId={productId} />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CheckLoginModal;
